import React, { useState } from "react";
import {
  Box,
  CircularProgress,
  Typography,
  FormControl,
  LinearProgress,
  Button,
  NativeSelect,
  InputBase,
  withStyles,
} from "@material-ui/core";
import moment from "moment";
import { scoreBand } from "../../utils/score-band";
import "./overall-performance-header.scss";

const OverallPerformanceHeader = (props) => {
  const { navigateToReview, performanceData, quizHistoryList, quizDetails } =
    props;

  const [quizSelected, setQuizSelected] = useState("");

  const handleChange = (event) => {
    setQuizSelected(event.target.value);
  };

  const BootstrapInput = withStyles((theme) => ({
    root: {
      "label + &": {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      border: "1px solid #ced4da",
      fontSize: 16,
      padding: "10px 26px 10px 12px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      "&:focus": {
        borderRadius: 4,
        borderColor: "#80bdff",
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      },
    },
  }))(InputBase);

  const latestQuiz = quizHistoryList && quizHistoryList[0];

  // D2: absence ≠ zero. A brand-new user with no quizzes must not read
  // "0% CORRECT" (a demoralizing false "I failed everything" signal). For a
  // zero-quiz user the backend leaves correctPercentage undefined (that's why
  // the old `?? 0` printed a false "0%"); a genuine 0%-correct user has it as
  // 0. Gate all numeric header UI on real data presence; otherwise show a
  // neutral "—" and an inviting next step.
  const hasScoreData =
    performanceData?.correctPercentage != null ||
    performanceData?.questionCorrect != null ||
    performanceData?.questionIncorrect != null;

  return (
    <Box component="div" className="overall-performance-header">
      <Box component="div" className="upper-header">
        <Box component="div" m={1} className="header-sidebar-left">
          <Typography component="h4" variant="h4" className="title">
            Overall Performance
          </Typography>
          <Typography component="h6" variant="h6" className="sub-title">
            Performance by Recent Test
          </Typography>
        </Box>
        <Box component="div" className="quiz-percent-cont">
          <Box component="div" className="quiz-percent-progress">
            <CircularProgress
              variant="determinate"
              className="circular-progress-bkg"
              size={80}
              thickness={2}
              value={100}
            />
            <CircularProgress
              variant="determinate"
              className={`op-score-ring op-score-ring--${scoreBand(hasScoreData ? performanceData?.correctPercentage : undefined)}`}
              size={80}
              thickness={2}
              value={hasScoreData ? (performanceData?.correctPercentage ?? 0) : 0}
            />
            <Box component="div" className="quiz-progress-text">
              {hasScoreData ? (
                <>
                  <Box component="div" className="quiz-progress-text-num">
                    {performanceData?.correctPercentage ?? 0}%
                  </Box>
                  Correct
                </>
              ) : (
                <Box component="div" className="quiz-progress-text-num" data-testid="op-score-empty">
                  —
                </Box>
              )}
            </Box>
          </Box>
          {hasScoreData ? (
            <Box component="div" className="report-details-wrapper">
              <Box component="div" className="report-details">
                <Box component="span" className="quiz-progress-text-bold">
                  {performanceData?.questionCorrect}
                </Box>
                Correct
              </Box>
              <Box component="div" className="report-details">
                <Box component="span" className="quiz-progress-text-bold">
                  {performanceData?.questionIncorrect}
                </Box>
                Incorrect
              </Box>
            </Box>
          ) : (
            <Box component="div" className="report-details-wrapper report-empty">
              <Typography variant="body2" className="op-empty-msg">
                No quizzes yet — take one to see your score.
              </Typography>
            </Box>
          )}
        </Box>
      </Box>

      {quizHistoryList &&
        <Box component="div" className="lower-header">
          <Box
            component="div"
            m={1}
            className="left-sidebar"
            onClick={() => navigateToReview(latestQuiz?.id)}
          >
            <Box component="div" className="sidebar-header">
              <Box component="div" className="sidebar-header-left">
                <Typography component="h6" variant="h6">
                  {latestQuiz?.name}
                </Typography>
                <Typography variant="overline" display="block">
                  {moment(quizDetails?.quizSubmitDate).format("lll")}
                </Typography>
                <Typography
                  variant="overline"
                  display="block"
                  className="sub-title"
                >
                  Tutor {latestQuiz?.tutorOn ? "On" : "Off"} - Timer
                  {latestQuiz?.timerOn ? " On" : " Off"}
                </Typography>
              </Box>
              <Box component="div" m={1} className="sidebar-header-right">
                {/* D9: the whole left-sidebar is already clickable → review,
                    so the redundant "REVIEW" text link is dropped; the % ring
                    stays the sole emphasis. */}
                <Typography variant="body1">
                  <strong>{quizDetails?.correctPercentage}%</strong> Correct
                </Typography>
              </Box>
            </Box>
            <LinearProgress
              variant="determinate"
              value={quizDetails?.correctPercentage || 0}
            />
          </Box>
          <Box component="div" className="right-sidebar">
            <Typography component="h6" variant="h6">
              All Quizzes:
            </Typography>
            <FormControl className="dropdown">
              <NativeSelect
                id="demo-customized-select"
                value={quizSelected}
                onChange={handleChange}
                input={<BootstrapInput />}
              >
                {quizHistoryList?.map((item, index) => (
                  <option value={item.id} key={index}>
                    {item.name}
                  </option>
                ))}
              </NativeSelect>
            </FormControl>
            <Button
              variant="contained"
              color="primary"
              className="review-btn"
              onClick={() => navigateToReview(quizSelected || latestQuiz.id)}
            >
              Review
            </Button>
          </Box>
        </Box>
      }
    </Box>
  );
};

export default OverallPerformanceHeader;
